// crewbit-admin/src/pages/Money/Expenses.tsx
//
// Page wrapper for /money/expenses. Mirrors the shape of Outstanding.tsx —
// the heavy lifting lives in the wrapper component.

import { MoneyExpensesAdmin } from '../../components/money/MoneyExpensesAdmin';

export function MoneyExpensesPage() {
  return <MoneyExpensesAdmin />;
}
